import type { Resource } from '../../';
export const cart_promotions_fallbackLabel: Resource = {"default":"Promotion"};
